import posthog, { isPosthogEnabled } from '@/lib/posthog';
import { getEnv } from '@/lib/env';
import { parseCookies } from '@/lib/cookies';

let context = null;

export const setWebpageContext = ctx => {
  context = ctx || null;
};

export const buildAgentWebpageContext = ({ info, webpageUsername }) => {
  const tenant = getEnv('NEXT_PUBLIC_RAILS_ENV') || 'unknown';
  const profile = info?.profile || info?.user?.profile || {};

  return {
    tenant,
    agent_key: `${tenant}:${webpageUsername || 'unknown'}`,
    agent_id: info?.user_id || info?.user?.id || null,
    agent_name: [profile.first_name, profile.last_name].filter(Boolean).join(' ') || null,
    is_internal_viewer: !!parseCookies()?.token
  };
};

const capture = event => {
  if (!isPosthogEnabled() || !context) return;
  posthog.capture(event, context);
};

export const trackWebpageViewed = () => capture('webpage_viewed');

export const trackWebpageFormSubmitted = () => capture('webpage_form_submitted');
